<template>
  <a-modal
    title="修改酒店行业"
    :visible="visible"
    :confirmLoading="confirmLoading"

    okText="提交"
    cancelText="取消"
    @ok="handlerSubmit"
    @cancel="() => $emit('close')"
    :afterClose="afterHideEditModal"
  >
    <a-form-model
      ref="shopForm"
      :model="shopForm"
      :rules="shopFormRules"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-model-item label="所属行业" prop="appId">
        <a-select v-model="shopForm.industryId" placeholder="请选择">
          <a-select-option v-for="(item,index) in industryList " :key="index" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
/*
* 	门店地址		false
	门店扩展参数1		false
* 	*/
import { AppIndex } from '@/apis/app'
import { QueryIndustrySimplifyList } from '@/apis/industry'

const shopForm = {
  id: undefined,
  industryId: undefined,
}
const shopFormRules = {
  industryId: [{ required: true, message: '请选择业务平台！' }]
}

export default {
  name: 'ChangeIndustryModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      shopForm,
      shopFormRules,
      adcOptions:[],
      templateList:[],
      industryList:[],
      uploading: false,
      confirmLoading:false,
    }
  },
  computed: {},
  watch: {
    visible: function (val){
      //
      if (val && this.obj){
        this.$nextTick(() => {
        })
      }
    }
  },

  created() {
    this.getIndustryList()
  },
  methods: {
    getIndustryList(){
      QueryIndustrySimplifyList().then(res=>{
        if (res.code === 0){
          this.industryList = res.collection
        }
      })
    },
    // 提交模态框数据
    handlerSubmit() {
      this.$refs.shopForm.validate(async valid => {
        if (valid) {
          this.$emit('submit', this.shopForm)
          this.confirmLoading = true
        }
      })
    },

    // 编辑终端标识组模态框关闭后，重置相关数据
    afterHideEditModal() {
      this.$refs.shopForm.resetFields()
      this.shopForm = shopForm
      this.confirmLoading = false
    },
  }
}
</script>

<style lang="less" scoped>
  ::v-deep .ant-modal{
    width: 700px !important
  }
  ::v-deep .ant-form-item{
    margin-bottom: 12px;
  }
  .ant-checkbox-group>.ant-checkbox-wrapper:first-child{
    margin-left: 8px !important;
  }
</style>
